<div class="body-indicator">
    <div class="header-indicator">
        <div class="row mt-4">
            <div class="col-12">
                <div class="form-inline">
                    <span class="badge badge-warning">
                        <span class="material-icons">
                            score
                        </span>
                    </span>
                    <h4 class="mt-2">Mis indicadores</h4>
                </div>
            </div>
        </div>
    </div>
    
    <div class="table-indicator">
        <ng-container *ngIf="user && user.indicators">
            <app-indicator-table-show [indicatorsIds]="user.indicators"></app-indicator-table-show>
        </ng-container>
    </div>
</div>